module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "connections",
    attrs: {
      "id": "developer-content-connections"
    }
  }, [(_vm.hasData) ? _c('section', {
    staticClass: "panels"
  }, [_c('section', {
    staticClass: "panel"
  }, [_c('h3', [_vm._v("Friends")]), _vm._v(" "), (_vm.profileConnections.friends && _vm.profileConnections.friends.length > 0) ? _c('ul', {
    staticClass: "follows-list"
  }, _vm._l((_vm.profileConnections.friends), function(friend) {
    return _c('li', [_c('avatar', {
      attrs: {
        "profile-data": friend,
        "profile-type": "developer",
        "size": "small",
        "show-xp-info": true
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (friend.stringUrl))
      }
    }, [_vm._v(_vm._s(friend.alias))])], 1)
  })) : _c('span', [_vm._v(_vm._s(_vm.profileAlias) + " hasn't made any friends yet")])]), _vm._v(" "), _c('section', {
    staticClass: "panel"
  }, [_c('h3', [_vm._v("Followers")]), _vm._v(" "), (_vm.profileConnections.followers && _vm.profileConnections.followers.length > 0) ? _c('ul', {
    staticClass: "follows-list"
  }, _vm._l((_vm.profileConnections.followers), function(follower) {
    return _c('li', [_c('avatar', {
      attrs: {
        "profile-data": follower,
        "profile-type": "developer",
        "size": "small",
        "show-xp-info": true
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (follower.stringUrl))
      }
    }, [_vm._v(_vm._s(follower.alias))])], 1)
  })) : _c('span', [_vm._v("No one is following " + _vm._s(_vm.profileAlias) + " yet.")])]), _vm._v(" "), _c('section', {
    staticClass: "panel"
  }, [_c('h3', [_vm._v("Following")]), _vm._v(" "), _c('nav', {
    staticClass: "switcher-options"
  }, [_c('ul', [_c('li', {
    class: {
      selected: _vm.selectedFollowingCategory === 'developers'
    },
    on: {
      "click": function($event) {
        _vm.switchSelectedFollowingCategory('developers')
      }
    }
  }, [_vm._v("Developers\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      selected: _vm.selectedFollowingCategory === 'games'
    },
    on: {
      "click": function($event) {
        _vm.switchSelectedFollowingCategory('games')
      }
    }
  }, [_vm._v("Games\n                    ")])])]), _vm._v(" "), (_vm.selectedFollowingCategory === 'developers') ? _c('section', {
    staticClass: "switcher-panel",
    staticStyle: {
      "display": "block"
    }
  }, [(_vm.profileConnections.followingDevelopers && _vm.profileConnections.followingDevelopers.length > 0) ? _c('ul', {
    staticClass: "follows-list"
  }, _vm._l((_vm.profileConnections.followingDevelopers), function(developer) {
    return _c('li', [_c('avatar', {
      attrs: {
        "profile-data": developer,
        "profile-type": "developer",
        "size": "small",
        "show-xp-info": true
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (developer.stringUrl))
      }
    }, [_vm._v(_vm._s(developer.alias))])], 1)
  })) : _c('span', [_vm._v(_vm._s(_vm.profileAlias) + " is not following any other Developers yet.")])]) : _vm._e(), _vm._v(" "), (_vm.selectedFollowingCategory === 'games') ? _c('section', {
    staticClass: "switcher-panel",
    staticStyle: {
      "display": "block"
    }
  }, [(_vm.profileConnections.followingGames && _vm.profileConnections.followingGames.length > 0) ? _c('ul', {
    staticClass: "follows-list"
  }, _vm._l((_vm.profileConnections.followingGames), function(game) {
    return _c('li', [_c('avatar', {
      attrs: {
        "profile-data": game,
        "profile-type": "game",
        "size": "small",
        "show-xp-info": true
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Game/" + (game.stringUrl))
      }
    }, [_vm._v(_vm._s(game.alias))])], 1)
  })) : _c('span', [_vm._v(_vm._s(_vm.profileAlias) + " is not following any Game Projects yet.")])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dae863be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/SubPages/DeveloperConnections.vue
// module id = 921
// module chunks = 2